import React, { Component } from "react";
import "./loader.css";
import loader from "../../assets/logo.svg"

const PreloaderInner = ({ loaderText }) => {
	return (
		<>
			<div class="preloader-bg">
				<div id="preloader">
				<object type="image/svg+xml" data={loader} >svg-animation</object>
					<p>{loaderText ? <span>{loaderText}</span> : <span>Loading&#8230;</span>}</p>
				</div>
			</div>
		</>
	);
}

export default PreloaderInner;